<template>
  <div class="v-select-multiple">
   <v-treeview
     :active.sync="active"
     :items="item"
     @update:active='updateValue'
     @input='inputValue'
     activatable
     open-all
     dense
     selectable
     v-bind='$attrs'
     selected-color='primary'
   >
   </v-treeview>
   <v-overlay :value="loading" absolute>
      <v-progress-circular
        indeterminate
        size="30"
      ></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import { tree } from '@/api/data.js'

export default {
  name: 'v-select_tree_mu',
  data () {
    return {
      item: [],
      active: [],
      loading: false
    }
  },
  props: {
    path: {
      type: String,
      required: true
    }
  },
  methods: {
    tree () {
      this.loading = true
      tree(this.path).then(res => {
        if (res.status === 200) {
          this.item = res.data
        }
        this.loading = false
      })
    },
    updateValue (value) {
      this.$emit('on-click', value)
    },
    inputValue (value) {
      this.$emit('input', value)
    }
  },
  created() {
    this.tree()
  }
}
</script>

<style lang="sass" scope>
  $color:  #676767
  $error_color: #ff5252
  .v-select-multiple
    .v-treeview
      .v-treeview-node__content
        cursor: pointer
</style>
